(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["armor-addon"] && !Shopify.designMode) return;
  try {
    class ArmorAddon extends HTMLElement {
    connectedCallback() {
      this.check = this.querySelector('[data-aad-check]');
      this.status = this.querySelector('[data-aad-status]');
      this.form = this.closest('form');
      if (!this.check || !this.dataset.variantId) return;

      // Only now is the offer one the page can keep.
      this.hidden = false;

      this.check.addEventListener('change', this.#onToggle);
      if (this.form) this.form.addEventListener('cart:add-failed', this.#onFailed);
    }

    disconnectedCallback() {
      if (!this.check) return;
      this.check.removeEventListener('change', this.#onToggle);
      if (this.form) this.form.removeEventListener('cart:add-failed', this.#onFailed);
    }

    /** The panel as a cart line, or nothing when the box is unticked. */
    items() {
      return this.check.checked ? [{ id: Number(this.dataset.variantId), quantity: 1 }] : [];
    }

    #onToggle = () => {
      this.#setStatus('');
    };

    #onFailed = () => {
      if (!this.check.checked) return;
      this.#setStatus('The ballistic panel could not be added. Please try again.');
    };

    #setStatus(text) {
      if (this.status) this.status.textContent = text;
    }
  }

  customElements.define('armor-addon', ArmorAddon);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["collection-filters"] && !Shopify.designMode) return;
  try {
    /**
   * Submits the filter form and swaps the results in place.
   *
   * The markup underneath already works: the groups are <details>, the bar is a
   * GET form, and every value is a real checkbox or a link. This adds three
   * things and nothing else — submit on change instead of on a button, replace
   * rather than reload, and one group open at a time.
   *
   * Every failure path falls back to a normal navigation, so a dropped fetch
   * costs a page load rather than a broken filter.
   */
  class CollectionFilters extends HTMLElement {
    connectedCallback() {
      this.form = this.querySelector('.filters__form');
      if (!this.form) return;

      this.addEventListener('change', this.onChange);
      this.addEventListener('click', this.onClick);
      this.addEventListener('toggle', this.onToggle, true);
      this.form.addEventListener('submit', this.onSubmit);
      document.addEventListener('click', this.onDocumentClick);
      document.addEventListener('keydown', this.onKeydown);
      window.addEventListener('popstate', this.onPopState);
    }

    disconnectedCallback() {
      document.removeEventListener('click', this.onDocumentClick);
      document.removeEventListener('keydown', this.onKeydown);
      window.removeEventListener('popstate', this.onPopState);
    }

    /**
     * One group at a time. `toggle` doesn't bubble, hence the capture phase.
     */
    onToggle = (event) => {
      const group = event.target;
      if (!group.matches('[data-filter-group]') || !group.open) return;

      this.querySelectorAll('[data-filter-group][open]').forEach((other) => {
        if (other !== group) other.open = false;
      });
    };

    onDocumentClick = (event) => {
      if (this.contains(event.target)) return;
      this.closeGroups();
    };

    onKeydown = (event) => {
      if (event.key !== 'Escape') return;

      const open = this.querySelector('[data-filter-group][open]');
      if (!open) return;

      // Focus would otherwise be left on an element that no longer exists in
      // any visible sense.
      open.querySelector('summary').focus();
      this.closeGroups();
    };

    closeGroups() {
      this.querySelectorAll('[data-filter-group][open]').forEach((group) => {
        group.open = false;
      });
    }

    onChange = (event) => {
      if (!event.target.matches('.filters__input, .filters__select, .filters__number')) return;
      this.navigate(this.url());
    };

    /**
     * Clear links are ordinary hrefs, so they work before this runs. Once it
     * has, they go through the same swap as everything else.
     */
    onClick = (event) => {
      const link = event.target.closest('.filters__clear, .filters__clear-all, .filters__active-item');
      if (!link) return;

      event.preventDefault();
      this.navigate(link.href);
    };

    onSubmit = (event) => {
      event.preventDefault();
      this.navigate(this.url());
    };

    /**
     * Build the URL from the form's own state.
     *
     * Empty fields are dropped rather than submitted blank — an untouched price
     * range would otherwise put `filter.v.price.gte=` in the URL and in history
     * for every single change. The sort goes the same way when it is still on
     * the collection's own default, so filtering doesn't mint a second URL for
     * a page that is already at /collections/x.
     */
    url() {
      const params = new URLSearchParams();
      const sort = this.querySelector('.filters__select');
      const defaultSort = sort ? sort.dataset.default : null;

      new FormData(this.form).forEach((value, key) => {
        if (String(value).trim() === '') return;
        if (key === 'sort_by' && value === defaultSort) return;
        params.append(key, value);
      });

      const query = params.toString();
      return this.form.action + (query ? '?' + query : '');
    }

    async navigate(url, push = true) {
      // Restored after the swap: selecting a value shouldn't shut the panel the
      // next value is in.
      const openIndex = this.openIndex();
      const focusKey = this.focusKey();

      this.setAttribute('data-loading', '');

      try {
        const response = await fetch(url);
        if (!response.ok) throw new Error(response.status);

        const html = new DOMParser().parseFromString(await response.text(), 'text/html');
        const filters = html.querySelector('collection-filters');
        const results = html.querySelector('[data-collection-results]');
        const target = document.querySelector('[data-collection-results]');
        if (!filters || !results || !target) throw new Error('missing region');

        this.innerHTML = filters.innerHTML;
        target.innerHTML = results.innerHTML;

        this.form = this.querySelector('.filters__form');
        this.form.addEventListener('submit', this.onSubmit);

        this.restore(openIndex, focusKey);
        if (push) history.pushState({}, '', url);
      } catch (error) {
        window.location.assign(url);
      } finally {
        this.removeAttribute('data-loading');
      }
    }

    onPopState = () => {
      this.navigate(window.location.href, false);
    };

    openIndex() {
      const groups = [...this.querySelectorAll('[data-filter-group]')];
      return groups.findIndex((group) => group.open);
    }

    /**
     * Identifies the focused control by name and value rather than by node,
     * since the node it was on is about to be replaced.
     */
    focusKey() {
      const active = document.activeElement;
      if (!active || !this.contains(active) || !active.name) return null;
      return active.name + ' ' + (active.type === 'checkbox' ? active.value : '');
    }

    restore(openIndex, focusKey) {
      if (openIndex > -1) {
        const group = this.querySelectorAll('[data-filter-group]')[openIndex];
        if (group) group.open = true;
      }

      if (!focusKey) return;

      const [name, value] = focusKey.split(' ');
      const match = [...this.querySelectorAll('[name="' + CSS.escape(name) + '"]')].find(
        (input) => (input.type === 'checkbox' ? input.value === value : true)
      );
      if (match) match.focus();
    }
  }

  customElements.define('collection-filters', CollectionFilters);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["combo-pack-holster"] && !Shopify.designMode) return;
  try {
    class ComboPackHolster extends HTMLElement {
    connectedCallback() {
      this.selector = this.querySelector('kydex-fit-selector');
      this.status = this.querySelector('[data-cph-status]');
      this.form = this.closest('form');
      this.atc = this.form ? this.form.querySelector('[data-atc]') : null;
      if (!this.selector || !this.form || !this.atc) return;

      this.selector.addEventListener('kfs:change', this.#sync);
      // Capture phase, ahead of `pdp-atc`'s own submit handler.
      this.form.addEventListener('submit', this.#onSubmit, true);
      this.form.addEventListener('cart:add-failed', this.#onFailed);
      // The variant picker re-enables the button on a variant change; the
      // shell has one variant, but take it back regardless.
      document.addEventListener('pdp:variant-change', this.#sync);

      this.#sync();
    }

    disconnectedCallback() {
      if (!this.selector || !this.form) return;
      this.selector.removeEventListener('kfs:change', this.#sync);
      this.form.removeEventListener('submit', this.#onSubmit, true);
      this.form.removeEventListener('cart:add-failed', this.#onFailed);
      document.removeEventListener('pdp:variant-change', this.#sync);
    }

    /** These lines go in place of the form's own: the shell is never posted. */
    replacesLine() {
      return true;
    }

    /** Pack, then holster, both tagged. Empty until the fit is complete. */
    items() {
      const holster = typeof this.selector.items === 'function' ? this.selector.items() : [];
      if (!holster.length) return [];
      const tag = { _combo: this.dataset.combo };
      return [
        { id: Number(this.dataset.packVariant), quantity: 1, properties: tag },
        { ...holster[0], properties: { ...holster[0].properties, ...tag } },
      ];
    }

    /**
     * The light-bearing holster costs more, so the combo does too. The shell
     * product carries one price (the no-light build); once a light is chosen
     * the page is re-priced from the real parts, less the same bundle saving
     * the "Sentinel Combo" automatic discount takes at checkout — so the price
     * shown is the price paid. All figures in cents.
     */
    #reprice() {
      const light = typeof this.selector.lightBearing === 'function' ? this.selector.lightBearing() : null;
      const pack = Number(this.dataset.packPrice);
      const standard = Number(this.dataset.holsterPrice);
      const holster = light ? Number(this.dataset.holsterPriceLight) : standard;
      const saving = pack + standard - Number(this.dataset.comboPrice);
      if (!pack || !holster || saving < 0) return;

      const full = pack + holster;
      const money = (cents) =>
        new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(cents / 100);

      const root = this.closest('pdp-product') || document;
      const price = root.querySelector('[data-price]');
      const compare = root.querySelector('[data-compare]');
      const save = root.querySelector('.pdp__price-save');
      if (price) price.textContent = money(full - saving);
      if (compare) compare.textContent = money(full);
      if (save) save.textContent = `You save ${money(saving)}`;
      const holsterLine = this.querySelector('[data-cph-holster-price]');
      const total = this.querySelector('[data-cph-total]');
      const totalSave = this.querySelector('[data-cph-save]');
      const totalCompare = this.querySelector('[data-cph-compare]');
      if (holsterLine) holsterLine.textContent = money(holster);
      if (total) total.textContent = money(full - saving);
      if (totalCompare) totalCompare.textContent = money(full);
      if (totalSave) totalSave.textContent = `Save ${money(saving)}`;
      document.querySelectorAll('.lsc__price').forEach((el) => (el.textContent = money(full - saving)));
    }

    #sync = () => {
      this.#reprice();
      const ready = this.items().length > 0;
      this.atc.disabled = !ready;
      const label = this.atc.querySelector('[data-atc-label]') || this.atc;
      const next = typeof this.selector.nextStep === 'function' ? this.selector.nextStep() : '';
      label.textContent = ready ? this.dataset.labelAdd : next || this.dataset.labelChoose;
      this.#setStatus('');
    };

    /**
     * Incomplete: hold the form and point at the gap. With no lines `pdp-atc`
     * would fall back to posting the form as-is — the shell — so this must
     * never let an empty submit through.
     */
    #onSubmit = (event) => {
      if (this.items().length) {
        this.#setStatus('');
        return;
      }
      event.preventDefault();
      event.stopImmediatePropagation();
      if (typeof this.selector.prompt === 'function') this.selector.prompt();
    };

    #onFailed = () => {
      this.#setStatus(this.dataset.error);
    };

    #setStatus(text) {
      if (this.status) this.status.textContent = text;
    }
  }

  customElements.define('combo-pack-holster', ComboPackHolster);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["holster-fit-finder"] && !Shopify.designMode) return;
  try {
    /**
   * Resolves a handgun + setup to a Mainstay size code and checks that size in
   * the native variant picker.
   *
   * It drives the picker rather than replacing it: check the radio, dispatch a
   * bubbling `change`, and `pdp-product`'s own delegated listener updates the
   * price, the availability and the id the form posts. Nothing here knows about
   * variants, and the picker stays usable on its own.
   */
  class HolsterFitFinder extends HTMLElement {
    connectedCallback() {
      const raw = this.querySelector('[data-hff-data]');
      if (!raw) return;

      try {
        this.data = JSON.parse(raw.textContent);
      } catch {
        // A malformed chart leaves the native picker as the only control,
        // which is the same state as this script never having loaded.
        return;
      }

      this.gunSel = this.querySelector('[data-hff-gun]');
      this.opticSel = this.querySelector('[data-hff-optic]');
      this.lightSel = this.querySelector('[data-hff-light]');
      this.status = this.querySelector('[data-hff-status]');
      this.sizeSel = this.querySelector('[data-hff-size]');
      this.toggle = this.querySelector('[data-hff-manual-toggle]');
      this.panel = this.querySelector('[data-hff-manual-panel]');
      if (!this.gunSel || !this.opticSel || !this.lightSel) return;

      // The picker is rendered by the same section, so it is a sibling up the
      // tree rather than a child of this element.
      this.picker = this.closest('pdp-product') || document;
      this.atc = this.picker.querySelector('[data-atc]');
      this.atcLabel = this.picker.querySelector('[data-atc-label]');

      // Nothing has been chosen yet. Shopify pre-checks the first size, so
      // "a size is selected" is not the same as "the customer selected one".
      this.chosen = false;

      this.#populate();
      this.addEventListener('change', this.#onChange);

      if (this.toggle && this.panel) {
        this.toggle.addEventListener('click', this.#onToggle);
      }

      /**
       * Take the native size buttons away only once there is proof this can
       * drive them — same bargain the live theme makes. A hidden picker plus a
       * broken tool is a product page with no way to choose a size.
       */
      if (this.#sizeGroup()) {
        this.#sizeGroup().setAttribute('data-hff-hidden', '');

        /**
         * Hiding the sizes means the pre-checked one can no longer be seen or
         * changed, so the button has to wait for a real choice — otherwise the
         * default (size 1) is one tap from the cart and the customer never saw
         * a size at all. The status line stays empty until then for the same
         * reason: announcing "Size 1 selected" beside a button that says
         * "Select your handgun" contradicts itself.
         *
         * Gated here rather than in the markup for the same reason the sizes
         * are hidden here: if this script does not run, the picker is visible
         * and the button must stay live.
         */
        this.#gate();
        this.picker.addEventListener('change', this.#regate);
      }
    }

    disconnectedCallback() {
      this.removeEventListener('change', this.#onChange);
      this.toggle?.removeEventListener('click', this.#onToggle);
      this.picker?.removeEventListener?.('change', this.#regate);
    }

    /** Hold the button closed until something has actually been chosen. */
    #gate() {
      if (!this.atc || this.chosen) return;

      this.atc.disabled = true;
      const label = this.dataset.labelChoose;
      if (label && this.atcLabel) this.atcLabel.textContent = label;
    }

    /**
     * Re-assert the gate after the picker's own handler has run.
     *
     * Both listeners sit on <pdp-product>, so ordering between them is a
     * registration-order accident; deferring by a task removes the race. It
     * matters because changing Magazine Pouch is a change like any other — the
     * picker re-enables the button on it, and without this that alone would
     * unlock a cart with the untouched default size in it.
     */
    #regate = () => {
      if (this.chosen) return;
      setTimeout(() => this.#gate(), 0);
    };

    /** The fieldset wrapping the size radios, found through one of them so the
     *  shared picker snippet needs no marker of its own. */
    #sizeGroup() {
      const radio = this.picker.querySelector('.pdp-options__input[data-option-position="1"]');
      return radio ? radio.closest('.pdp-options__group') : null;
    }

    #onToggle = () => {
      this.panel.hidden = false;
      this.toggle.setAttribute('aria-expanded', 'true');

      // Focus follows the disclosure, or a keyboard user is left where the
      // control they just operated used to be.
      this.sizeSel?.focus();
    };

    #populate() {
      const frag = document.createDocumentFragment();

      for (const entry of this.data.guns) {
        const option = document.createElement('option');
        option.value = entry.gun;
        option.textContent = entry.gun;
        frag.append(option);
      }

      this.gunSel.append(frag);
    }

    #entry() {
      return this.data.guns.find((g) => g.gun === this.gunSel.value) || null;
    }

    #onChange = (event) => {
      /**
       * A manual size is an override, so the handgun is cleared with it —
       * otherwise the page shows a handgun and a size the chart does not agree
       * on, and neither the customer nor anyone reading a support ticket can
       * tell which one won.
       */
      if (event.target === this.sizeSel) {
        // The placeholder is not a size.
        if (!this.sizeSel.value) return;

        this.gunSel.value = '';
        this.chosen = true;
        this.#apply(this.sizeSel.value);
        this.#setStatus(`Size ${this.sizeSel.value} selected.`);
        return;
      }

      if (!event.target.matches('[data-hff-gun], [data-hff-optic], [data-hff-light]')) return;

      const entry = this.#entry();
      if (!entry) {
        this.#setStatus('');
        return;
      }

      this.#syncAvailability(entry);

      const optic = this.opticSel.value === 'yes';
      const light = this.lightSel.value === 'yes';

      let size = entry.base;
      if (optic && light) size = entry.optic_light;
      else if (optic) size = entry.optic;
      else if (light) size = entry.light;

      /**
       * A null here means the chart does not offer that setup for this handgun,
       * not that some nearby size will do. `#syncAvailability` disables those
       * choices before they can be picked, so this is the belt to that braces —
       * and it stops rather than guessing, because a guessed size is a holster
       * the customer's firearm does not fit.
       */
      if (!size) {
        this.#setStatus('That setup is not offered for this handgun.');
        return;
      }

      if (!this.#apply(size)) {
        this.#setStatus('');
        return;
      }

      this.chosen = true;

      // Keep the manual dropdown showing what the chart chose, so opening it
      // after using the selectors starts from the resolved size.
      if (this.sizeSel) this.sizeSel.value = size;
      this.#setStatus(`Size ${size} selected.`);
    };

    /**
     * Disable the setups this handgun has no size for, so an unofferable
     * combination cannot be reached. A choice already on `yes` when it becomes
     * unavailable is put back to `no` — leaving it selected but disabled would
     * show a setup the customer cannot actually buy.
     */
    #syncAvailability(entry) {
      const pairs = [
        [this.opticSel, entry.optic || entry.optic_light],
        [this.lightSel, entry.light || entry.optic_light],
      ];

      for (const [select, offered] of pairs) {
        const yes = select.querySelector('option[value="yes"]');
        if (!yes) continue;

        yes.disabled = !offered;
        if (!offered && select.value === 'yes') select.value = 'no';
      }
    }

    /** Check the size radio and let the picker's own listener do the rest. */
    #apply(size) {
      const radios = this.picker.querySelectorAll('.pdp-options__input[data-option-position="1"]');

      for (const radio of radios) {
        if (radio.value !== size) continue;

        /**
         * Dispatched even when the radio is already checked. It looks
         * redundant, and skipping it was a bug: Shopify pre-checks size 1, so
         * choosing size 1 changed no radio, fired no event, and left the picker
         * to never recompute — which meant the button it had disabled stayed
         * disabled for that one size.
         *
         * The picker's handler only reads the checked values and updates from
         * them, so running it again with the same values is idempotent.
         */
        radio.checked = true;
        radio.dispatchEvent(new Event('change', { bubbles: true }));
        return true;
      }

      return false;
    }

    #setStatus(text) {
      if (this.status) this.status.textContent = text;
    }
  }

  customElements.define('holster-fit-finder', HolsterFitFinder);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["hydration-addon"] && !Shopify.designMode) return;
  try {
    class HydrationAddon extends HTMLElement {
    connectedCallback() {
      this.check = this.querySelector('[data-had-check]');
      this.status = this.querySelector('[data-had-status]');
      this.product = this.closest('pdp-product');
      if (!this.check || !this.product) return;

      const radios = Array.from(
        this.product.querySelectorAll(
          `.pdp-options__input[data-option-position="${this.dataset.optionPosition}"]`
        )
      );
      this.addRadio = radios.find((radio) => radio.value === this.dataset.addValue);
      this.noneRadio = radios.find((radio) => radio.value === this.dataset.noneValue);
      if (!this.addRadio || !this.noneRadio) return;

      try {
        this.variants = JSON.parse(this.product.querySelector('[data-variants]').textContent);
      } catch {
        this.variants = [];
      }

      // Only now is the box one the page can keep, so only now do the chips
      // give way to it.
      const group = this.addRadio.closest('.pdp-options__group');
      if (group) group.hidden = true;
      this.hidden = false;

      this.check.checked = this.addRadio.checked;
      this.#syncAvailability();

      this.check.addEventListener('change', this.#onToggle);
      document.addEventListener('pdp:variant-change', this.#onVariantChange);
    }

    disconnectedCallback() {
      if (!this.check) return;
      this.check.removeEventListener('change', this.#onToggle);
      document.removeEventListener('pdp:variant-change', this.#onVariantChange);
    }

    #onToggle = () => {
      const radio = this.check.checked ? this.addRadio : this.noneRadio;
      radio.checked = true;
      // `pdp-product` listens for a bubbling change from the radios themselves.
      radio.dispatchEvent(new Event('change', { bubbles: true }));
    };

    #onVariantChange = () => {
      this.#syncAvailability();
    };

    /**
     * A colour whose reservoir variant is sold out can't take the tick. If it
     * was ticked when the colour changed, fall back to the pack on its own
     * rather than leave the button on "Sold out" for a pack that is in stock.
     */
    #syncAvailability() {
      const index = Number(this.dataset.optionPosition) - 1;
      const chosen = Array.from(
        this.product.querySelectorAll('.pdp-options__input:checked')
      ).map((radio) => radio.value);

      const withReservoir = chosen.slice();
      withReservoir[index] = this.dataset.addValue;
      const variant = this.variants.find((candidate) =>
        candidate.options.every((option, i) => option === withReservoir[i])
      );
      const available = Boolean(variant && variant.available);

      this.check.disabled = !available;
      this.#setStatus(available ? '' : 'The reservoir is sold out in this color.');

      if (!available && this.check.checked) {
        this.check.checked = false;
        this.#onToggle();
      }
    }

    #setStatus(text) {
      if (this.status) this.status.textContent = text;
    }
  }

  customElements.define('hydration-addon', HydrationAddon);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["kydex-addon"] && !Shopify.designMode) return;
  try {
    class KydexAddon extends HTMLElement {
    connectedCallback() {
      this.check = this.querySelector('[data-kad-check]');
      this.panel = this.querySelector('[data-kad-panel]');
      this.price = this.querySelector('[data-kad-price]');
      this.status = this.querySelector('[data-kad-status]');
      this.selector = this.querySelector('kydex-fit-selector');
      this.form = this.closest('form');
      if (!this.check || !this.panel || !this.selector) return;

      // Only now is the offer one the page can keep.
      this.hidden = false;

      this.check.addEventListener('change', this.#onToggle);
      this.selector.addEventListener('kfs:change', this.#onSelection);
      // Capture phase, ahead of the button's own submit handler.
      if (this.form) {
        this.form.addEventListener('submit', this.#onSubmit, true);
        this.form.addEventListener('cart:add-failed', this.#onFailed);
      }

      // A bfcache restore can bring the box back ticked with the panel shut.
      this.#onToggle();
    }

    disconnectedCallback() {
      this.check.removeEventListener('change', this.#onToggle);
      this.selector.removeEventListener('kfs:change', this.#onSelection);
      if (this.form) {
        this.form.removeEventListener('submit', this.#onSubmit, true);
        this.form.removeEventListener('cart:add-failed', this.#onFailed);
      }
    }

    /** The insert as a cart line, or nothing when the box is unticked. */
    items() {
      return this.check.checked ? this.selector.items() : [];
    }

    #onToggle = () => {
      const on = this.check.checked;
      this.panel.hidden = !on;
      this.check.setAttribute('aria-expanded', String(on));
      this.#setStatus('');
      this.#syncPrice();
    };

    #onSelection = () => {
      this.#setStatus('');
      this.#syncPrice();
    };

    /** The price follows the light: a light-bearing build is the dearer variant. */
    #syncPrice() {
      if (!this.price) return;
      const light = this.check.checked && this.selector.selection && this.selector.selection.light;
      this.price.textContent = '+ ' + (light ? this.dataset.priceLight : this.dataset.priceStandard);
    }

    /** Ticked but not configured: hold the form, say why, put focus on the gap. */
    #onSubmit = (event) => {
      if (!this.check.checked || this.selector.complete) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      this.#setStatus('Finish choosing your holster, or untick it to buy the pack on its own.');
      this.selector.prompt();
    };

    #onFailed = () => {
      if (!this.check.checked) return;
      this.#setStatus('The holster could not be added. Please try again.');
    };

    #setStatus(text) {
      if (this.status) this.status.textContent = text;
    }
  }

  customElements.define('kydex-addon', KydexAddon);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["kydex-fit-selector"] && !Shopify.designMode) return;
  try {
    class KydexFitSelector extends HTMLElement {
    connectedCallback() {
      const data = this.querySelector('[data-kfs-data]');
      if (!data) return;
      try {
        this.data = JSON.parse(data.textContent);
      } catch {
        return;
      }

      this.modelSel = this.querySelector('[data-kfs-model]');
      this.lightSel = this.querySelector('[data-kfs-light]');
      this.hands = Array.from(this.querySelectorAll('[data-kfs-hand]'));
      this.status = this.querySelector('[data-kfs-status]');
      this.props = {
        model: this.querySelector('[data-kfs-prop="model"]'),
        hand: this.querySelector('[data-kfs-prop="hand"]'),
        code: this.querySelector('[data-kfs-prop="code"]'),
      };
      this.form = this.closest('form');
      this.atc = this.form ? this.form.querySelector('[data-atc]') : null;
      this.complete = false;

      // Add-on: a second line item inside another product's form. The form,
      // its chips and its button are the pack's; `kydex-addon` reads `items()`
      // and guards the submit itself. See the doc block.
      this.addon = this.hasAttribute('data-addon');
      // The configuration as last resolved, for the host to read. Null until
      // complete; `light` is whether the build is light-bearing.
      this.selection = null;
      this.variantId = null;

      this.addEventListener('change', this.#onChange);

      if (!this.addon) {
        // The Version chips belong to this control now; see the stylesheet.
        const versionRadio = this.#variantRadio(this.dataset.variantLight) || this.#variantRadio(this.dataset.variantStandard);
        if (versionRadio) {
          const group = versionRadio.closest('.pdp-options__group');
          if (group) group.setAttribute('data-kfs-hidden', '');
        }

        document.addEventListener('pdp:variant-change', this.#onVariantChange);
        // Capture phase, so this runs before the button's own submit handler.
        if (this.form) this.form.addEventListener('submit', this.#onSubmit, true);
      }

      this.#sync();
    }

    disconnectedCallback() {
      this.removeEventListener('change', this.#onChange);
      document.removeEventListener('pdp:variant-change', this.#onVariantChange);
      if (this.form) this.form.removeEventListener('submit', this.#onSubmit, true);
    }

    /**
     * The insert as a cart line, for a host that posts several items at once.
     * Empty until the fit is complete, so a host can spread it unconditionally.
     */
    items() {
      if (!this.complete || !this.selection || !this.variantId) return [];
      return [
        {
          id: Number(this.variantId),
          quantity: 1,
          properties: {
            Model: this.selection.model,
            Hand: this.selection.hand,
            'Order Sheet Code': this.selection.code,
          },
        },
      ];
    }

    /**
     * The button label for the first step still missing, so a shut button
     * says what to do next rather than repeating "Select your handgun" after
     * the handgun is chosen. Empty once the fit is complete.
     */
    nextStep() {
      const model = this.#model();
      if (!model) return this.dataset.labelChoose || 'Select your handgun';
      if (!this.#light()) return 'Select your weapon light';
      if (!this.#hand()) return 'Choose your draw hand';
      return '';
    }

    /**
     * Whether the chosen light makes this the light-bearing version: true or
     * false once a light is picked, null before. Lets a combo re-price itself
     * the moment the light is chosen, not only once the fit is complete.
     */
    lightBearing() {
      const light = this.#light();
      return light ? Boolean(light.light) : null;
    }

    /** Point the customer at the first thing still missing. */
    prompt() {
      this.#setStatus('Choose your handgun, light and draw hand first.');
      (this.modelSel.value ? this.lightSel : this.modelSel).focus();
    }

    #model() {
      return this.data.models.find((m) => m.id === this.modelSel.value) || null;
    }

    #light() {
      const model = this.#model();
      if (!model || this.lightSel.value === '') return null;
      return model.lights[Number(this.lightSel.value)] || null;
    }

    #hand() {
      const checked = this.hands.find((r) => r.checked);
      return checked ? checked.value : '';
    }

    #onChange = (event) => {
      if (event.target === this.modelSel) this.#fillLights();
      this.#sync();
    };

    /** Only the lights the chosen model is made for. "No light" is always first. */
    #fillLights() {
      const model = this.#model();
      this.lightSel.replaceChildren();

      if (!model) {
        this.lightSel.append(new Option('Select your handgun first', ''));
        this.lightSel.disabled = true;
        return;
      }

      // A model with only "No light" gets it chosen for it — a one-item
      // dropdown asking for a decision is a step with no decision in it.
      if (model.lights.length > 1) this.lightSel.append(new Option('Select your light', ''));
      model.lights.forEach((light, i) => this.lightSel.append(new Option(light.name, String(i))));
      this.lightSel.disabled = false;
      this.lightSel.value = model.lights.length > 1 ? '' : '0';
    }

    #sync() {
      const model = this.#model();
      const light = this.#light();

      // A configuration the list has only one hand for (it happens) disables
      // the other chip rather than guessing the code from its sibling.
      for (const radio of this.hands) {
        const offered = !light || Boolean(light[radio.value]);
        radio.disabled = !offered;
        if (!offered && radio.checked) radio.checked = false;
      }

      const hand = this.#hand();
      const entry = light && hand ? light[hand] : null;

      if (!entry) {
        this.complete = false;
        this.selection = null;
        this.variantId = null;
        this.#setProps(null);
        if (!this.addon) this.#setButton(false);
        this.#setStatus(this.#hint(model, light, hand));
        this.#emit();
        return;
      }

      this.selection = {
        model: entry.model,
        hand: hand === 'right' ? 'Right' : 'Left',
        code: entry.code,
        light: Boolean(light.light),
      };
      this.#setProps(this.selection);
      // Before the variant is applied: the picker announces the change and
      // the listener below reads this flag to decide whether to re-lock.
      this.complete = true;

      if (this.addon) {
        this.variantId = light.light ? this.dataset.addonVariantLight : this.dataset.addonVariantStandard;
      } else {
        this.#applyVariant(light.light);
      }

      // Read back exactly what will be molded, at the moment it's decided. A
      // holster built for the wrong gun can't be resold, so this is the last
      // cheap place to catch a slip (2026-09-30, Brendon).
      this.#setStatus(`${model.name} · ${light.name} · ${this.selection.hand} hand`, true);
      this.#emit();
    }

    /** For the add-on host: the price line follows the light. */
    #emit() {
      this.dispatchEvent(
        new CustomEvent('kfs:change', {
          bubbles: true,
          detail: { complete: this.complete, selection: this.selection },
        })
      );
    }

    #hint(model, light, hand) {
      if (!model) return '';
      if (!light) return 'Choose a weapon light, or "No light".';
      if (!hand) {
        const only = ['right', 'left'].filter((h) => light[h]);
        return only.length === 1 ? `This model is made for ${only[0]}-hand draw only.` : 'Choose your draw hand.';
      }
      return '';
    }

    #setProps(values) {
      for (const [key, input] of Object.entries(this.props)) {
        if (!input) continue;
        input.value = values ? values[key] : '';
        input.disabled = !values;
      }
    }

    /**
     * The light decides the Version, and the native picker does the rest —
     * price, the id the form posts, the button's sold-out state. Dispatched
     * even when the radio is already checked, so the picker recomputes and
     * re-enables the button it was told to keep shut.
     */
    #applyVariant(hasLight) {
      const value = hasLight ? this.dataset.variantLight : this.dataset.variantStandard;
      const radio = this.#variantRadio(value);
      if (radio) {
        radio.checked = true;
        radio.dispatchEvent(new Event('change', { bubbles: true }));
        return;
      }
      // Single-variant product: no picker to defer to.
      this.#setButton(true);
    }

    #variantRadio(value) {
      if (!value || !this.form) return null;
      return Array.from(this.form.querySelectorAll('.pdp-options__input')).find((r) => r.value === value) || null;
    }

    /** The picker re-enabled the button for a variant change; take it back until the fit is complete. */
    #onVariantChange = () => {
      if (!this.complete) this.#setButton(false);
    };

    #onSubmit = (event) => {
      if (this.complete) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      this.prompt();
    };

    #setButton(enabled) {
      if (!this.atc) return;
      this.atc.disabled = !enabled;
      const label = this.atc.querySelector('[data-atc-label]') || this.atc;
      label.textContent = enabled ? this.atc.dataset.labelAdd : this.nextStep() || this.dataset.labelChoose;
    }

    #setStatus(text, confirmed = false) {
      if (!this.status) return;
      this.status.classList.toggle('kfs__status--confirm', confirmed && Boolean(text));
      if (confirmed && text) {
        // One run of text beside the tick, so the label and the fit wrap
        // together instead of standing in two columns.
        const line = document.createElement('span');
        const label = document.createElement('strong');
        label.textContent = 'Molded for: ';
        line.append(label, text);
        this.status.replaceChildren(line);
      } else {
        this.status.textContent = text;
      }
    }
  }

  customElements.define('kydex-fit-selector', KydexFitSelector);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["lander-alt-offer"] && !Shopify.designMode) return;
  try {
    class LanderAltOffer extends HTMLElement {
    connectedCallback() {
      this.button = this.querySelector('[data-lao-button]');
      this.status = this.querySelector('[data-lao-status]');
      if (this.button) this.button.addEventListener('click', this.#add);
    }

    disconnectedCallback() {
      if (this.button) this.button.removeEventListener('click', this.#add);
    }

    #add = async (event) => {
      event.preventDefault();
      this.button.setAttribute('aria-busy', 'true');
      this.status.textContent = '';
      try {
        const response = await fetch(window.Shopify.routes.root + 'cart/add.js', {
          method: 'POST',
          headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [{ id: Number(this.dataset.variant), quantity: 1 }] }),
        });
        if (!response.ok) throw new Error(response.status);
        await response.json();
        document.dispatchEvent(new CustomEvent('cart:changed'));
      } catch (error) {
        this.status.textContent = "Couldn't add the pack. Please try again.";
      }
      this.button.removeAttribute('aria-busy');
    };
  }

  customElements.define('lander-alt-offer', LanderAltOffer);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-accordion"] && !Shopify.designMode) return;
  try {
    class PdpAccordion extends HTMLElement {
    connectedCallback() {
      this.details = this.querySelector('details');
      this.summary = this.querySelector('summary');
      this.panel = this.querySelector('[data-panel]');
      if (!this.details || !this.summary || !this.panel) return;

      this.reduceMotion = matchMedia('(prefers-reduced-motion: reduce)');
      this.expanded = this.details.open;
      this.summary.addEventListener('click', this.onClick);
    }

    disconnectedCallback() {
      if (this.summary) this.summary.removeEventListener('click', this.onClick);
      if (this.animation) this.animation.cancel();
    }

    onClick = (event) => {
      // Let the browser do its normal thing when motion is unwelcome, and when
      // the element hasn't upgraded — that path needs no JavaScript at all.
      if (this.reduceMotion.matches) return;

      event.preventDefault();

      /**
       * A closed <details> reports its panel at full height, not zero — the
       * child is laid out inside a slot the browser hides, so it still
       * measures. Trusting that would animate from the target to the target
       * and nothing would move, so a closed panel starts from 0 by definition
       * and only a visible one is measured.
       *
       * Measuring before cancelling matters too: cancel snaps the panel back,
       * so a click mid-flight has to read the height while it is still moving.
       */
      const from = this.animation || this.expanded
        ? this.panel.getBoundingClientRect().height
        : 0;

      if (this.animation) this.animation.cancel();

      // Tracked separately from `details.open`, which stays true for the whole
      // closing animation and so can't say which way the panel is heading.
      this.expanded = !this.expanded;

      if (this.expanded) {
        this.details.open = true;
        this.run(from, this.panel.scrollHeight, null);
      } else {
        this.run(from, 0, () => {
          this.details.open = false;
        });
      }
    };

    run(from, to, done) {
      this.panel.style.height = from + 'px';

      /**
       * Sitka's panel is animated frame by frame in JavaScript, not by a CSS
       * transition — its computed transition-duration is 0s — so there is no
       * duration or easing to read off it. What there is, is the curve itself,
       * sampled off their live PDP: a spring starting from rest, which is why
       * it creeps for the first ~50ms before accelerating, and why no
       * cubic-bezier fits it (ease-out curves are ~20 points ahead early).
       *
       * These are those samples, as offset/progress pairs. Interpolating
       * linearly between them reproduces the measured shape without needing
       * the CSS `linear()` easing function, which is younger than the browsers
       * this theme supports.
       *
       * ⚠️ RETIMED, and deliberately no longer Sitka's timing. Measured on the
       * TrailGuard at 375px: the old 850ms run spent 26ms at a dead stop before
       * anything moved, and its last 330ms covered the final 1.5% of a 410px
       * panel — invisible, but `details.open` waited for all of it, so a closed
       * row stayed pinned open for 300ms after it looked shut. That is the
       * "sticky" feel, and it was never dropped frames: pacing held 8.25ms the
       * whole way.
       *
       * So the curve below is the VISIBLE part of Sitka's spring — their
       * samples from offset 0.031 to 0.612 — renormalised to 0-1 and run in
       * 400ms. Same shape, none of the dead air. Turn DURATION up if it wants
       * to feel more languid; do not reinstate the flat head and tail.
       */
      const curve = PdpAccordion.CURVE;
      const distance = to - from;

      this.animation = this.panel.animate(
        curve.map(([offset, progress]) => ({
          offset: offset,
          height: from + distance * progress + 'px',
        })),
        { duration: PdpAccordion.DURATION, easing: 'linear' }
      );

      this.animation.onfinish = () => {
        this.animation = null;
        // Back to auto, so the panel reflows with its content afterwards
        // instead of being pinned to the height it happened to open at.
        this.panel.style.height = '';
        if (done) done();
      };
    }
  }

  /**
   * Sampled from sitkagear.com, then trimmed to the stretch you can actually
   * see and renormalised to offset (0-1) / progress (0-1). See the note in
   * run() for what was cut and why.
   */
  PdpAccordion.DURATION = 400;

  PdpAccordion.CURVE = [
    [0, 0],
    [0.0534, 0.0335],
    [0.1205, 0.1766],
    [0.191, 0.3431],
    [0.2582, 0.4954],
    [0.3253, 0.6264],
    [0.3924, 0.7269],
    [0.4613, 0.803],
    [0.5284, 0.8609],
    [0.5938, 0.9036],
    [0.6627, 0.934],
    [0.7298, 0.9563],
    [0.7986, 0.9736],
    [0.8657, 0.9848],
    [0.9329, 0.9939],
    [1, 1],
  ];

  customElements.define('pdp-accordion', PdpAccordion);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-card"] && !Shopify.designMode) return;
  try {
    /**
   * Colour swatches on the card, switching the picture in place.
   *
   * Delegated from the document rather than bound per card, for two reasons:
   * cards arrive after load — the collection's Load More appends them and the
   * recommendations row injects a whole rowful — and one listener is cheaper
   * than one per tile on a 24-card grid.
   *
   * Each swatch is a real link to its variant, so with no script the click goes
   * to that colour's product page. This only intercepts it.
   */
  document.addEventListener('click', (event) => {
    const swatch = event.target.closest('[data-swatch]');
    if (!swatch) return;

    // Leave modified clicks alone — opening a colour in a new tab is reasonable.
    if (event.metaKey || event.ctrlKey || event.shiftKey || event.button !== 0) return;

    const group = swatch.closest('[data-card-swatches]');
    const card = swatch.closest('.card');
    if (!group || !card) return;

    event.preventDefault();

    group.querySelectorAll('[data-swatch]').forEach((other) => {
      const current = other === swatch;
      other.classList.toggle('card__color--current', current);
      if (current) other.setAttribute('aria-current', 'true');
      else other.removeAttribute('aria-current');
    });

    // Not every colour has its own photograph. Where one is missing the card
    // keeps the picture it had rather than blanking, and the colour still
    // registers as chosen.
    const image = card.querySelector('.card__image');
    const source = swatch.dataset.image;
    if (image && source) {
      image.srcset = [200, 300, 400, 600, 800]
        .map((width) => `${source.replace(/width=\d+/, 'width=' + width)} ${width}w`)
        .join(', ');
      image.src = source;
    }

    // The flag follows the colour, which is the whole point: one product can be
    // US-made in one colourway and imported in another.
    const origin = card.querySelector('.card__origin');
    if (origin) origin.hidden = swatch.dataset.usa !== 'true';

    // So the card itself now leads to the colour on show.
    const link = card.querySelector('.card__link');
    if (link) link.href = swatch.getAttribute('href');
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-featured-review"] && !Shopify.designMode) return;
  try {
    /**
   * The counter, and nothing else.
   *
   * Paging belongs to `snippets/scroll-arrows.liquid` now — this used to carry
   * its own copy of the scroll maths, which was the third in the theme and the
   * reason the shared control exists. What is left is the one thing the shared
   * control has no opinion about: which quote is on screen.
   *
   * Read off the track's own scroll rather than off the button presses, so a
   * swipe and a press are counted the same way and neither has to tell it.
   */
  class PdpQuotes extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-scroller]');
      this.counter = this.querySelector('[data-count]');
      if (!this.track || !this.counter) return;

      /* Passive: this only reads scroll position to label the counter, so it
         must never be able to block the scroll it is watching. */
      this.track.addEventListener('scroll', () => this.sync(), { passive: true });
      this.sync();
    }

    /** The slide nearest the start of the track, which is the one on screen. */
    get index() {
      const trackLeft = this.track.getBoundingClientRect().left;
      const current = this.track.scrollLeft;
      const positions = [...this.track.children].map((slide) =>
        Math.round(current + slide.getBoundingClientRect().left - trackLeft)
      );

      let nearest = 0;
      positions.forEach((position, i) => {
        if (Math.abs(position - current) < Math.abs(positions[nearest] - current)) nearest = i;
      });
      return nearest;
    }

    sync() {
      this.counter.textContent = `${this.index + 1} / ${this.track.children.length}`;
    }
  }

  if (!customElements.get('pdp-quotes')) {
    customElements.define('pdp-quotes', PdpQuotes);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-gallery"] && !Shopify.designMode) return;
  try {
    class PdpGallery extends HTMLElement {
    connectedCallback() {
      this.rail = this.querySelector('[data-rail]');
      this.slides = Array.from(this.querySelectorAll('[data-slide]'));
      this.counter = this.querySelector('[data-count-current]');
      this.active = 0;

      if (!this.rail || this.slides.length < 2) return;

      // An IntersectionObserver rather than a scroll listener: no work on every
      // frame of a swipe, so dragging stays off the main thread.
      this.observer = new IntersectionObserver(
        (entries) => {
          /**
           * The single most visible slide in this batch — not "the last one
           * that happened to be intersecting".
           *
           * The observer's first callback reports every slide at once, and on
           * first paint, before the images have been laid out, more than one of
           * them clears the threshold. Looping and letting the last win meant a
           * freshly loaded gallery could open reading "6 / 7" on slide one.
           *
           * `>` rather than `>=` keeps the earliest slide on a tie, which is
           * what makes the initial state resolve to the first.
           */
          const visible = entries.filter((entry) => entry.isIntersecting);
          if (!visible.length) return;

          const best = visible.reduce((a, b) =>
            b.intersectionRatio > a.intersectionRatio ? b : a
          );

          this.setActive(this.visualIndex(best.target));
        },
        { root: this.rail, threshold: 0.6 }
      );

      for (const slide of this.slides) this.observer.observe(slide);

      /**
       * Pin the counter from the rail's actual scroll position, rather than
       * trusting the observer's first callback for it.
       *
       * A freshly loaded gallery was opening on slide one while reading "6 / 7",
       * so something was reporting a late slide as active before anyone had
       * scrolled. Scroll position cannot lie about which slide is showing:
       * offset zero is slide one, whatever the observer thinks. Run once now and
       * again after load, since the rail has no width until it is laid out.
       */
      this.syncFromScroll();
      window.addEventListener('load', this.syncFromScroll);

      this.addEventListener('click', this.onClick);

      this.more = this.querySelector('[data-gallery-more]');

      // Below 990px the rail is a scrollable carousel; above it, a static grid.
      // The markup ships tabindex="0" so it's keyboard-scrollable without JS —
      // this drops it on desktop, where it would be a tab stop that does nothing.
      this.isCarousel = matchMedia('(max-width: 989px)');
      this.syncMode();
      this.isCarousel.addEventListener('change', this.syncMode);

      // The product element announces variant changes; the gallery reacts.
      // Matching on media id rather than index keeps this correct even when the
      // rail skips non-image media.
      /**
       * Move the chosen variant's shot to the front of the gallery.
       *
       * The class does the reordering — see `--lead` in the stylesheet — so
       * nothing is re-rendered and document order never changes. The rail is
       * then sent back to its start, because after the swap position zero IS
       * the variant, and leaving it parked mid-row would hide the picture the
       * shopper just asked for.
       *
       * A variant with no image of its own carries no mediaId. Nothing leads in
       * that case and the previous lead is cleared, rather than stranding some
       * other variant's shot at the front.
       */
      this.onVariantChange = (event) => {
        const mediaId = event.detail && event.detail.mediaId;

        const lead = mediaId
          ? this.slides.find((slide) => slide.dataset.mediaId === String(mediaId))
          : null;

        for (const slide of this.slides) {
          slide.classList.toggle('pdp-gallery__slide--lead', slide === lead);
        }

        if (!lead) return;

        const reduceMotion = matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.rail.scrollTo({ left: 0, behavior: reduceMotion ? 'auto' : 'smooth' });
        this.setActive(0);
      };
      document.addEventListener('pdp:variant-change', this.onVariantChange);
    }

    disconnectedCallback() {
      if (this.observer) this.observer.disconnect();
      window.removeEventListener('load', this.syncFromScroll);
      this.removeEventListener('click', this.onClick);
      if (this.isCarousel) this.isCarousel.removeEventListener('change', this.syncMode);
      document.removeEventListener('pdp:variant-change', this.onVariantChange);
    }

    syncMode = () => {
      if (this.isCarousel.matches) {
        this.rail.setAttribute('tabindex', '0');
      } else {
        this.rail.removeAttribute('tabindex');
      }
    };

    onClick = (event) => {
      if (this.more && event.target.closest('[data-gallery-more]')) this.toggleRest();
    };

    /**
     * Show or hide everything past the sixth image. The button stays put and
     * relabels itself, so focus is never lost the way it would be if the
     * control removed itself on use.
     *
     * ⚠️ The viewport is pinned across the toggle.
     *
     * This control sits BELOW the grid it expands, and revealing fifteen more
     * shots grows the page by ~2,600px entirely above it. The browser's scroll
     * anchoring reads that as "keep the thing you were looking at still",
     * chooses the button, and scrolls the document down by the full amount —
     * which drops the shopper underneath every picture they just asked to see,
     * facing a wall of nothing, having to scroll UP to find them.
     *
     * Recording `scrollY` and putting it back makes the reveal behave the way a
     * show-more is expected to: the page does not move, and the new images fill
     * in below. Belt and braces with `overflow-anchor: none` in the stylesheet —
     * the CSS stops the browser compensating, this guarantees the position.
     *
     * Collapsing shortens the grid by several hundred pixels and can leave the
     * button off screen above, so that direction still pulls it back into view;
     * `nearest` scrolls only if it actually left.
     */
    toggleRest() {
      const open = this.more.getAttribute('aria-expanded') === 'true';
      const anchor = window.scrollY;

      this.more.setAttribute('aria-expanded', String(!open));
      if (open) delete this.dataset.expanded;
      else this.dataset.expanded = '';

      if (open) {
        this.more.scrollIntoView({ block: 'nearest' });
        return;
      }

      // Expanding only. Restored on the next frame, after layout has taken the
      // new rows into account — reading it back any sooner pins the old height.
      requestAnimationFrame(() => window.scrollTo({ top: anchor, behavior: 'auto' }));
    }

    /**
     * A slide's place as the shopper sees it, not in the document.
     *
     * The lead variant's shot is moved to the front with CSS `order`, so its
     * document index (e.g. 17) is not its position on screen (0). Ranking by
     * offsetLeft counts what is actually to its left, which is what the
     * counter has to say. Forty slides, one callback per swipe: cheap.
     *
     * Only slides that are shown count: when a variant's shot leads, the
     * original first slide is stood down (zero width), so it is neither
     * "before" anything nor part of the total.
     */
    visibleSlides() {
      return this.slides.filter((slide) => slide.offsetWidth > 0);
    }

    syncTotal() {
      if (!this.total) this.total = this.querySelector('[data-count-total]');
      if (this.total) this.total.textContent = this.visibleSlides().length || this.slides.length;
    }

    visualIndex(target) {
      const x = target.offsetLeft;
      return this.visibleSlides().filter((slide) => slide !== target && slide.offsetLeft < x).length;
    }

    /**
     * Which slide the rail is actually parked on. Guarded because clientWidth
     * is zero before layout, and zero-division would set the counter to NaN.
     */
    syncFromScroll = () => {
      if (!this.rail || !this.rail.clientWidth) return;

      this.syncTotal();
      const index = Math.round(this.rail.scrollLeft / this.rail.clientWidth);
      this.setActive(Math.min(Math.max(index, 0), this.slides.length - 1));
    };

    setActive(index) {
      if (index < 0 || index === this.active) return;
      this.active = index;
      if (this.counter) this.counter.textContent = index + 1;
      this.syncTotal();
      this.warm(index);
    }

    /**
     * Start the next slides downloading before the thumb reaches them.
     *
     * Every slide ships `loading="lazy"`, which is right for a rail of twenty
     * images on first paint but wrong once someone is swiping: the fetch only
     * begins as the slide approaches, so each swipe was followed by a visible
     * wait while 50-90KB arrived. Flipping `loading` to eager on an image that
     * has not started yet begins the request immediately, so the picture is
     * usually there before the swipe lands.
     *
     * Two ahead, not all of them — the point is to stay one step in front of
     * the finger, not to pull the whole gallery down on the first swipe.
     */
    warm(from) {
      for (let i = from + 1; i <= from + 2; i += 1) {
        const img = this.slides[i]?.querySelector('img');
        if (img && img.loading === 'lazy') img.loading = 'eager';
      }
    }

    goTo(index) {
      const slide = this.slides[index];
      if (!slide) return;

      const reduceMotion = matchMedia('(prefers-reduced-motion: reduce)').matches;
      const behavior = reduceMotion ? 'auto' : 'smooth';

      if (this.rail.scrollWidth > this.rail.clientWidth) {
        this.rail.scrollTo({ left: index * this.rail.clientWidth, behavior });
      } else {
        // Desktop grid: nothing scrolls sideways, so bring the image into view
        // down the page instead of silently doing nothing.
        slide.scrollIntoView({ behavior, block: 'nearest' });
      }
    }
  }

  customElements.define('pdp-gallery', PdpGallery);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-lightbox"] && !Shopify.designMode) return;
  try {
    (() => {
    if (!window.HTMLDialogElement) return;

    const ZOOM = 3;
    const ICONS = {
      close: 'M18 6 6 18M6 6l12 12',
      prev: 'M15 18 9 12l6-6',
      next: 'M9 18l6-6-6-6',
    };

    let dialog, stage, image, counter, prevBtn, nextBtn;
    let slides = [];
    let index = 0;
    let opener = null;

    // Zoom and pan state. `scale` is 1 or ZOOM; x and y are the pan offset in
    // px, applied before the scale so the maths stays in screen units.
    let scale = 1;
    let x = 0;
    let y = 0;

    const icon = (d) =>
      `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><path d="${d}"/></svg>`;

    // Button labels come from the JSON block this snippet renders above, since
    // Liquid does not run inside a javascript tag. Read lazily — this is only
    // ever called from the first open, by which point the block is parsed.
    const strings = () => {
      try {
        return JSON.parse(document.querySelector('[data-lightbox-strings]')?.textContent || '{}');
      } catch {
        return {};
      }
    };

    /**
     * Destroy the dialog rather than leaving it hidden in the DOM.
     *
     * A thin near-black band was left across the page under the gallery on
     * iPhone once the zoom had been opened and closed. Hiding the closed dialog
     * and its backdrop with CSS did not clear it, which points at WebKit not
     * releasing the top-layer compositing layer `showModal` created — and a
     * layer the compositor still holds cannot be reached by a style rule.
     * Removing the node it belongs to is what releases it.
     *
     * Cheap, because `build()` already creates the dialog on demand: this just
     * returns the page to its pre-first-open state. The warmed-image cache is
     * module scoped and survives, so reopening refetches nothing.
     */
    const teardown = () => {
      if (!dialog) return;

      reset();
      opener?.focus();

      dialog.remove();
      dialog = null;
      stage = image = counter = prevBtn = nextBtn = null;
    };

    // Close and tear down in one step, for the paths we trigger ourselves.
    const dismiss = () => {
      dialog?.close();
      teardown();
    };

    const build = () => {
      const label = strings();

      dialog = document.createElement('dialog');
      dialog.className = 'lightbox';
      dialog.innerHTML = `
        <div class="lightbox__stage" data-stage>
          <img class="lightbox__image" data-image alt="">
          <button class="lightbox__button lightbox__close" type="button" data-close>${icon(ICONS.close)}</button>
          <button class="lightbox__button lightbox__prev" type="button" data-prev>${icon(ICONS.prev)}</button>
          <button class="lightbox__button lightbox__next" type="button" data-next>${icon(ICONS.next)}</button>
          <p class="lightbox__counter" data-counter aria-live="polite"></p>
        </div>`;
      document.body.append(dialog);

      stage = dialog.querySelector('[data-stage]');
      image = dialog.querySelector('[data-image]');
      counter = dialog.querySelector('[data-counter]');
      prevBtn = dialog.querySelector('[data-prev]');
      nextBtn = dialog.querySelector('[data-next]');

      const closeBtn = dialog.querySelector('[data-close]');

      // setAttribute rather than interpolating into the markup above: these are
      // merchant-editable strings, and an apostrophe in a translation would
      // otherwise close the attribute.
      closeBtn.setAttribute('aria-label', label.close || '');
      prevBtn.setAttribute('aria-label', label.prev || '');
      nextBtn.setAttribute('aria-label', label.next || '');

      closeBtn.addEventListener('click', dismiss);
      prevBtn.addEventListener('click', () => show(index - 1));
      nextBtn.addEventListener('click', () => show(index + 1));

      image.addEventListener('click', onImageClick);
      image.addEventListener('pointerdown', onPointerDown);

      // A click that lands on the stage but not the image is a click on the
      // surround, which should dismiss — the same as clicking a backdrop.
      stage.addEventListener('click', (event) => {
        if (event.target === stage) dismiss();
      });

      dialog.addEventListener('keydown', (event) => {
        if (event.key === 'ArrowRight') show(index + 1);
        if (event.key === 'ArrowLeft') show(index - 1);
      });

      /**
       * ⚠️ Wired to close AND cancel, and dismiss() covers the rest.
       *
       * `close` is the correct event and fires on Escape and on `close()` in a
       * conforming engine — but it was observed never firing at all in one
       * environment, which would have left the teardown permanently unrun and
       * any fix placed inside it dead code. `cancel` covers Escape
       * independently, and dismiss() covers the button and the backdrop, so no
       * single engine quirk can strand the dialog. teardown() is safe to call
       * twice, and it is what restores focus to whatever opened the zoom.
       */
      dialog.addEventListener('close', teardown);
      dialog.addEventListener('cancel', () => requestAnimationFrame(teardown));
    };

    const apply = (animate) => {
      image.toggleAttribute('data-animate', !!animate);
      image.style.transform = `translate(${x}px, ${y}px) scale(${scale})`;
      dialog.toggleAttribute('data-zoomed', scale !== 1);
    };

    const reset = () => {
      scale = 1;
      x = 0;
      y = 0;
      apply(false);
    };

    /**
     * Keep the image covering the stage: at 3x there is more image than stage,
     * and the pan is clamped to the overflow on each axis so an edge can never
     * be dragged into view.
     */
    const clamp = () => {
      const box = stage.getBoundingClientRect();

      /**
       * Sized from `offsetWidth`, not from a bounding rect. A rect reports the
       * element as it is currently transformed, and this runs before the new
       * transform is applied — so on the first zoom it would still be reading
       * the unscaled image, compute zero overflow, clamp the pan to nothing and
       * land the zoom dead centre instead of on the point clicked. Layout size
       * times the target scale is the size we are about to have.
       */
      const width = image.offsetWidth * scale;
      const height = image.offsetHeight * scale;

      const overflowX = Math.max(0, (width - box.width) / 2);
      const overflowY = Math.max(0, (height - box.height) / 2);

      x = Math.min(overflowX, Math.max(-overflowX, x));
      y = Math.min(overflowY, Math.max(-overflowY, y));
    };

    /**
     * Zoom toward the point clicked rather than the middle.
     *
     * The point under the cursor is measured from the image's centre at the
     * current scale. Scaling about the centre moves that point out by the
     * factor, so translating by `point * (1 - factor)` puts it back where the
     * cursor is — which is what makes the zoom feel aimed rather than generic.
     */
    const onImageClick = (event) => {
      if (dragged) return;

      if (scale !== 1) {
        reset();
        apply(true);
        return;
      }

      const rect = image.getBoundingClientRect();
      const px = event.clientX - (rect.left + rect.width / 2);
      const py = event.clientY - (rect.top + rect.height / 2);

      scale = ZOOM;
      x = px * (1 - ZOOM);
      y = py * (1 - ZOOM);
      clamp();
      apply(true);
    };

    let dragged = false;
    let startX = 0;
    let startY = 0;
    let originX = 0;
    let originY = 0;

    const onPointerDown = (event) => {
      if (scale === 1) return;

      dragged = false;
      startX = event.clientX - x;
      startY = event.clientY - y;
      originX = event.clientX;
      originY = event.clientY;
      image.setPointerCapture(event.pointerId);
      dialog.setAttribute('data-panning', '');

      const move = (moveEvent) => {
        x = moveEvent.clientX - startX;
        y = moveEvent.clientY - startY;

        // Four pixels of slop, so a click with a shaky hand is still a click
        // and is not swallowed as a drag.
        if (Math.hypot(moveEvent.clientX - originX, moveEvent.clientY - originY) > 4) {
          dragged = true;
        }

        clamp();
        apply(false);
      };

      const up = (upEvent) => {
        image.releasePointerCapture(upEvent.pointerId);
        dialog.removeAttribute('data-panning');
        image.removeEventListener('pointermove', move);
        image.removeEventListener('pointerup', up);
        image.removeEventListener('pointercancel', up);

        // Cleared on the next frame so the click that follows this pointerup
        // can still see it.
        requestAnimationFrame(() => requestAnimationFrame(() => { dragged = false; }));
      };

      image.addEventListener('pointermove', move);
      image.addEventListener('pointerup', up);
      image.addEventListener('pointercancel', up);
    };

    /**
     * The URL this slide opens at full size.
     *
     * `data-zoom-src` is the 2048px file; the rail's own <img> is the fallback
     * for anything that opts into the lightbox without one.
     */
    const source = (slide) => {
      const img = slide?.querySelector('img');
      return slide?.dataset.zoomSrc || img?.currentSrc || img?.src || '';
    };

    /**
     * Warm a neighbouring slide's full-size file.
     *
     * These are 180–850KB each, and `show` used to fetch one from cold on every
     * arrow press — measured at 430–940ms per step on a fast connection, which
     * is the entire reason stepping through the gallery felt broken. Fetching
     * the neighbours while the current image is being looked at turns that into
     * a memory-cache hit, so the next press is instant.
     *
     * Only ever the two adjacent slides, not the whole gallery: a six-shot PDP
     * is 2.5MB of zoom files and nobody opens all of them.
     */
    const warmed = new Set();
    const warm = (at) => {
      if (slides.length < 2) return;
      const url = source(slides[(at + slides.length) % slides.length]);
      if (!url || warmed.has(url)) return;
      warmed.add(url);

      const pre = new Image();
      pre.decoding = 'async';
      pre.src = url;
    };

    // Guards against a fast clicker: each call claims a ticket, and a load that
    // finishes after a newer one started is dropped instead of overwriting it.
    let ticket = 0;

    const show = async (next) => {
      index = (next + slides.length) % slides.length;
      const slide = slides[index];
      const img = slide.querySelector('img');
      const url = source(slide);

      // Chrome updates immediately — waiting on the image would make the arrows
      // feel unresponsive even though the counter already knows the answer.
      counter.textContent = `${index + 1} / ${slides.length}`;

      const single = slides.length < 2;
      prevBtn.hidden = single;
      nextBtn.hidden = single;
      counter.hidden = single;

      reset();

      const mine = ++ticket;
      const alt = img?.alt || '';

      const loader = new Image();
      loader.decoding = 'async';
      loader.src = url;

      // This slide is now loading in its own right, so a later `warm` pass
      // reaching it as a neighbour has nothing left to do.
      warmed.add(url);

      if (loader.complete) {
        // Already in memory — a warmed neighbour, or a slide being revisited.
        // Assign synchronously so opening and stepping never wait a frame.
        image.src = url;
        image.alt = alt;
      } else {
        /**
         * Nothing cached yet: put the rail's own thumbnail up first. It is
         * already decoded, so it paints instantly and the stage shows the RIGHT
         * photo immediately — softer for a moment, then sharpening.
         *
         * The alternative, waiting for the 2048px file before touching the
         * stage, leaves the previous photo sitting there after an arrow press,
         * which reads as the control being broken rather than as loading.
         */
        const thumb = img?.currentSrc || img?.src;
        if (thumb) {
          image.src = thumb;
          image.alt = alt;
        }

        dialog.setAttribute('data-loading', '');
        try {
          await loader.decode();
        } catch {
          // Not fatal — fall through and let the <img> deal with the URL
          // itself, including falling back to its alt text.
        }

        // A newer navigation started while this loaded; that one owns the stage.
        if (mine !== ticket) return;

        dialog.removeAttribute('data-loading');
        image.src = url;
        image.alt = alt;
      }

      warm(index + 1);
      warm(index - 1);
    };

    const open = (container, target) => {
      if (!dialog) build();

      slides = [...container.querySelectorAll('[data-slide]')];
      if (!slides.length) return;

      opener = target;
      const slide = target.closest('[data-slide]');
      show(Math.max(0, slides.indexOf(slide)));
      dialog.showModal();
    };

    document.addEventListener('click', (event) => {
      /**
       * Two ways in: a bare image (the PDP gallery) or a real control wrapping
       * one (`[data-zoom-open]`, used by the review photos).
       *
       * Matching the control as well as the image is what lets a <button> carry
       * this, and a button is what makes the lightbox reachable without a
       * mouse: pressing Enter fires a click whose target is the BUTTON, so an
       * image-only selector drops every keyboard activation silently. The
       * gallery's own behaviour is unchanged — an img still matches directly.
       */
      const trigger = event.target.closest(
        '[data-lightbox] img, [data-lightbox] [data-zoom-open]'
      );
      if (!trigger) return;

      const img = trigger.tagName === 'IMG' ? trigger : trigger.querySelector('img');
      if (!img) return;

      // Never hijack a modified click — it may be someone opening the image in
      // a new tab.
      if (event.metaKey || event.ctrlKey || event.shiftKey || event.button !== 0) return;

      event.preventDefault();

      // The trigger, not the image, is what focus returns to on close — an
      // <img> is not focusable, so handing it back would drop focus to <body>.
      open(trigger.closest('[data-lightbox]'), trigger);
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-origin"] && !Shopify.designMode) return;
  try {
    /**
   * Shows or hides the origin mark as the variant changes.
   *
   * Only present on products whose variants disagree about origin. It reads the
   * picker's own `pdp:variant-change` event rather than watching inputs, so it
   * stays correct however the variant was chosen — the size dropdowns on the
   * Mainstay drive that same event.
   *
   * A variant missing from the map has no override and falls back to the tag,
   * which is what the server already rendered — so it is left alone.
   */
  class ProductOrigin extends HTMLElement {
    connectedCallback() {
      const raw = this.querySelector('[data-origin-map]');

      // The mark is a sibling inside the title group; scope the lookup to the
      // product so a page holding more than one cannot cross the wires.
      const root = this.closest('pdp-product') || document;
      this.mark = root.querySelector('.pdp__origin');
      if (!raw || !this.mark) return;

      try {
        this.map = JSON.parse(raw.textContent);
      } catch {
        // Leave whatever the server rendered rather than guessing an origin.
        return;
      }

      /**
       * Bound to `document`, not to <pdp-product>.
       *
       * The picker dispatches `pdp:variant-change` on the document rather than
       * on itself, and an event fired there does not travel down to a
       * descendant — so a listener on the element never hears it. That is why
       * the mark first stayed visible on the Scabbard's Black variant, which is
       * the one product this whole path exists for.
       */
      document.addEventListener('pdp:variant-change', this.onVariant);
    }

    disconnectedCallback() {
      document.removeEventListener('pdp:variant-change', this.onVariant);
    }

    onVariant = (event) => {
      const id = event.detail?.variant?.id;
      if (id == null) return;

      const origin = this.map[String(id)];
      if (origin === undefined) return;

      this.mark.hidden = !origin;
    };
  }

  customElements.define('product-origin', ProductOrigin);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["quantity-breaks"] && !Shopify.designMode) return;
  try {
    class QuantityBreaks extends HTMLElement {
    connectedCallback() {
      this.radios = Array.from(this.querySelectorAll('[data-qb-radio]'));
      this.selects = Array.from(this.querySelectorAll('[data-qb-select]'));
      this.fields = Array.from(this.querySelectorAll('[data-qb-field]'));
      this.panel = this.querySelector('[data-qb-panel]');
      this.status = this.querySelector('[data-qb-status]');
      this.form = this.closest('form');
      this.idInput = this.form ? this.form.querySelector('[data-variant-id]') : null;

      try {
        this.variants = JSON.parse(this.querySelector('[data-qb-variants]').textContent);
      } catch (error) {
        return;
      }
      if (!this.radios.length || !this.idInput) return;

      try {
        this.packs = JSON.parse(this.querySelector('[data-qb-packs]').textContent) || {};
      } catch (error) {
        this.packs = {};
      }

      this.money = new Intl.NumberFormat(document.documentElement.lang || 'en', {
        style: 'currency',
        currency: this.dataset.currency || 'USD',
      });

      this.fits = Array.from(this.querySelectorAll('[data-qb-fit]'));
      if (this.dataset.fit === 'holster' && !this.#setUpFit()) return;

      // Only now is the offer one the page can keep.
      this.hidden = false;

      this.addEventListener('change', this.#onChange);
      document.addEventListener('pdp:variant-change', this.#onVariant);
      this.form.addEventListener('cart:add-failed', this.#onFailed);

      this.#render();
    }

    disconnectedCallback() {
      this.removeEventListener('change', this.#onChange);
      document.removeEventListener('pdp:variant-change', this.#onVariant);
      if (this.form) this.form.removeEventListener('cart:add-failed', this.#onFailed);
    }

    /**
     * The pack for the chosen sizes as the one cart line; or, where no pack
     * exists for them, the units beyond the first beside the form's own.
     */
    items() {
      const pack = this.#pack();
      if (pack) return [{ id: pack.id, quantity: 1 }];
      return this.#extraIds().map((id) => ({ id, quantity: 1 }));
    }

    /** Whether `items()` stands in for the form's own line rather than joining it. */
    replacesLine() {
      return Boolean(this.#pack());
    }

    get quantity() {
      const checked = this.radios.find((radio) => radio.checked);
      return checked ? Number(checked.value) : 1;
    }

    #mainId() {
      return Number(this.idInput.value);
    }

    #extraIds(quantity = this.quantity) {
      const ids = [];
      for (let n = 2; n <= quantity; n += 1) {
        if (this.fits.length) {
          ids.push(this.#fitId(this.fits[n - 2]));
          continue;
        }
        const select = this.selects[n - 2];
        ids.push(select ? Number(select.value) : this.#mainId());
      }
      return ids;
    }

    /**
     * Fit mode needs the fit finder's chart, read from the same section so there
     * is one copy of it. Without the chart there is no safe way to size an
     * extra holster, so the offer stays hidden and the page sells one, as now.
     */
    #setUpFit() {
      const scope = this.closest('pdp-product') || document;
      const raw = scope.querySelector('[data-hff-data]');
      if (!raw || !this.fits.length) return false;
      try {
        this.chart = JSON.parse(raw.textContent);
      } catch (error) {
        return false;
      }

      this.fits.forEach((fit) => {
        const gun = fit.querySelector('[data-qb-gun]');
        const guns = document.createElement('optgroup');
        guns.label = 'Handguns';
        this.chart.guns.forEach((entry) => guns.append(new Option(entry.gun, `gun:${entry.gun}`)));

        // The fit finder's escape hatch, as the tail of the same list: only the
        // sizes this product actually sells.
        const sold = new Set(this.variants.map((variant) => variant.options[0]));
        const sizes = document.createElement('optgroup');
        sizes.label = 'Handgun not listed? Choose a size';
        this.chart.sizes
          .filter((size) => sold.has(size))
          .forEach((size) => sizes.append(new Option(`Size ${size}`, `size:${size}`)));

        gun.append(guns, sizes);
      });
      return true;
    }

    /** The variant an extra holster's answers come to, or the main one's size. */
    #fitId(fit) {
      if (!fit) return this.#mainId();
      const size = this.#fitSize(fit) || this.#variant(this.#mainId())?.options[0];
      const extra = fit.querySelector('[data-qb-extra]');
      const options = extra ? [size, extra.checked ? extra.dataset.on : extra.dataset.off] : [size];
      const match = this.variants.find((variant) => options.every((value, i) => variant.options[i] === value));
      return match ? match.id : this.#mainId();
    }

    /**
     * The size the chart gives for a handgun and setup — the same resolution
     * as `holster-fit-finder`. Null for "same as holster 1", and for a setup
     * the chart doesn't offer, which `#syncFit` keeps from being chosen.
     */
    #fitSize(fit) {
      const value = fit.querySelector('[data-qb-gun]').value;
      if (value.startsWith('size:')) return value.slice(5);
      if (!value.startsWith('gun:')) return null;

      const entry = this.chart.guns.find((candidate) => candidate.gun === value.slice(4));
      if (!entry) return null;
      const optic = fit.querySelector('[data-qb-optic]').value === 'yes';
      const light = fit.querySelector('[data-qb-light]').value === 'yes';
      if (optic && light) return entry.optic_light;
      if (optic) return entry.optic;
      if (light) return entry.light;
      return entry.base;
    }

    /**
     * Shows the setup questions only for a handgun from the list, disables the
     * setups the chart has no size for (putting a "yes" back to "no", as the
     * fit finder does), prices the pouch checkbox, and says which size it is.
     */
    #syncFit(fit) {
      const value = fit.querySelector('[data-qb-gun]').value;
      const setup = fit.querySelector('[data-qb-setup]');
      const status = fit.querySelector('[data-qb-fit-status]');
      const entry = value.startsWith('gun:')
        ? this.chart.guns.find((candidate) => candidate.gun === value.slice(4))
        : null;

      setup.hidden = !entry;
      if (entry) {
        [
          [fit.querySelector('[data-qb-optic]'), entry.optic || entry.optic_light],
          [fit.querySelector('[data-qb-light]'), entry.light || entry.optic_light],
        ].forEach(([select, offered]) => {
          const yes = select.querySelector('option[value="yes"]');
          yes.disabled = !offered;
          if (!offered && select.value === 'yes') select.value = 'no';
        });
        // Both offered on their own but not together (a few pocket .380s).
        const optic = fit.querySelector('[data-qb-optic]');
        const light = fit.querySelector('[data-qb-light]');
        if (optic.value === 'yes' && light.value === 'yes' && !entry.optic_light) light.value = 'no';
      }

      const variant = this.#variant(this.#fitId(fit));
      const extra = fit.querySelector('[data-qb-extra]');
      const extraPrice = fit.querySelector('[data-qb-extra-price]');
      if (extra && extraPrice && variant) {
        const without = this.variants.find(
          (candidate) => candidate.options[0] === variant.options[0] && candidate.options[1] === extra.dataset.off
        );
        const withIt = this.variants.find(
          (candidate) => candidate.options[0] === variant.options[0] && candidate.options[1] === extra.dataset.on
        );
        extraPrice.textContent =
          without && withIt ? `(+${this.money.format((withIt.price - without.price) / 100)})` : '';
      }

      if (status && variant) {
        const size = variant.options[0];
        status.textContent = variant.available
          ? value
            ? `Size ${size}.`
            : ''
          : `Size ${size} is sold out. Please choose another.`;
      }
    }

    #variant(id) {
      return this.variants.find((candidate) => candidate.id === id) || null;
    }

    #pack(quantity = this.quantity) {
      if (quantity < 2) return null;
      const key = [this.#mainId(), ...this.#extraIds(quantity)].sort((a, b) => a - b).join('+');
      return this.packs[key] || null;
    }

    #price(id) {
      const variant = this.variants.find((candidate) => candidate.id === id);
      return variant ? variant.price : 0;
    }

    #onChange = (event) => {
      // A size the customer chose stops following the page's own picker.
      if (event.target.matches('[data-qb-select]')) event.target.dataset.touched = 'true';
      this.#setStatus('');
      this.#render();
    };

    #onVariant = (event) => {
      const id = String(event.detail.variant.id);
      this.selects.forEach((select) => {
        if (select.dataset.touched) return;
        if (Array.from(select.options).some((option) => option.value === id)) select.value = id;
      });
      this.#render();
    };

    #onFailed = () => {
      if (this.quantity < 2) return;
      this.#setStatus('Those could not be added. Please try again.');
    };

    #render() {
      const chosen = this.quantity;

      this.fields.forEach((field) => {
        field.hidden = Number(field.dataset.qbField) > chosen;
      });
      this.fits.forEach((fit) => this.#syncFit(fit));
      // The sizes belong to the chosen row, so the panel sits directly under
      // it rather than under the whole list.
      if (this.panel) {
        this.panel.hidden = chosen < 2;
        const row = this.radios.find((radio) => radio.checked)?.closest('.qb__row');
        if (row && row.nextElementSibling !== this.panel) row.after(this.panel);
      }

      this.radios.forEach((radio) => {
        const row = radio.closest('.qb__row');
        const quantity = Number(radio.value);
        const percent = Number(radio.dataset.percent);

        // Rows other than the chosen one are priced as that many of what is
        // selected now: the extra selects as they stand, the rest the main size.
        const prices = [this.#mainId(), ...this.#extraIds(quantity)].map((id) => this.#price(id));
        const full = prices.reduce((sum, price) => sum + price, 0);
        // The pack's own price where there is one. Otherwise what the automatic
        // discount will make it: the percentage off each unit, fraction dropped.
        const pack = this.#pack(quantity);
        const total = pack
          ? pack.price
          : prices.reduce((sum, price) => sum + price - Math.floor((price * percent) / 100), 0);

        const price = row.querySelector('[data-qb-price]');
        const was = row.querySelector('[data-qb-was]');
        const each = row.querySelector('[data-qb-each]');
        if (price) price.textContent = this.money.format(total / 100);
        if (was) was.textContent = percent ? this.money.format(full / 100) : '';
        if (each) {
          const same = prices.every((value) => value === prices[0]);
          each.textContent = same
            ? `${this.money.format((total / quantity) / 100)} each`
            : `You save ${this.money.format((full - total) / 100)}`;
        }
      });
    }

    #setStatus(text) {
      if (this.status) this.status.textContent = text;
    }
  }

  customElements.define('quantity-breaks', QuantityBreaks);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["returns-policy-dialog"] && !Shopify.designMode) return;
  try {
    (() => {
    const dialog = document.getElementById('return-policy');
    if (!dialog || typeof dialog.showModal !== 'function') return;

    let opener = null;

    // Any link to #return-policy opens it: the Returns row, the landing
    // page's guarantee, anything added later.
    document.addEventListener('click', (event) => {
      const link = event.target.closest('a[href="#return-policy"]');
      if (!link) return;
      event.preventDefault();
      opener = link;
      dialog.showModal();
      dialog.scrollTop = 0;
    });

    dialog.addEventListener('click', (event) => {
      // The close button, or a click on the backdrop outside the panel.
      if (event.target.closest('[data-rpd-close]') || event.target === dialog) dialog.close();
    });

    // Focus back where it came from, so keyboard users don't lose their place.
    dialog.addEventListener('close', () => {
      if (opener) opener.focus();
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["reveal-on-scroll"] && !Shopify.designMode) return;
  try {
    (() => {
    // The whole effect is decoration. Without the observer, or where motion is
    // unwelcome, the markup is already correct and this simply never runs —
    // which is also why the hidden state is never written in the stylesheet
    // alone.
    if (!('IntersectionObserver' in window)) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    const DURATION = 350;
    const SHIFT = 15;

    // 53ms per item at Truewerk's measured pace, but capped: past ~17 items the
    // curve has flattened so far that more delay buys nothing but waiting.
    const STEP = 53;
    const MAX_TOTAL = 900;

    /**
     * Sine ease-out over the group. `i` is 1-based so the first child is
     * already offset — their first item starts at 82ms rather than 0, which is
     * what stops the group reading as one block appearing at once.
     */
    const delayFor = (i, count) => {
      const total = Math.min(count * STEP, MAX_TOTAL);
      return total * Math.sin((i / count) * (Math.PI / 2));
    };

    const reveal = (container) => {
      const items = [...container.children];

      items.forEach((item, index) => {
        const delay = delayFor(index + 1, items.length);
        const options = { duration: DURATION, delay, easing: 'ease', fill: 'both' };

        item.animate({ opacity: [0, 1] }, options);
        item.animate(
          { transform: [`translateY(${SHIFT}px)`, 'translateY(0)'] },
          options
        );
      });

      // The attribute is what the stylesheet hangs the hidden state on, so it
      // has to come off once the animation owns the element — otherwise a finished
      // reveal would still be described as pending.
      container.removeAttribute('data-reveal-ready');
    };

    /**
     * Anything already on screen when the page loads is shown outright, without
     * animating.
     *
     * The observer's first callback reports everything currently intersecting,
     * so that batch is exactly "was visible before anyone scrolled". Animating
     * it would mean above-the-fold content starting at `opacity: 0` — on a
     * collection page the grid is the LCP element, and this would have held it
     * back by up to 900ms to decorate something nobody scrolled to. A reveal is
     * for content you arrive at.
     */
    let firstPass = true;

    const observer = new IntersectionObserver(
      (entries) => {
        for (const entry of entries) {
          if (!entry.isIntersecting) continue;
          observer.unobserve(entry.target);

          if (firstPass) {
            entry.target.removeAttribute('data-reveal-ready');
            continue;
          }

          reveal(entry.target);
        }

        firstPass = false;
      },
      {
        // Fires a little before the container's top edge arrives, so the first
        // item is already moving by the time it is properly in view.
        rootMargin: '0px 0px -10% 0px',
        threshold: 0,
      }
    );

    const observe = (root) => {
      for (const container of root.querySelectorAll('[data-reveal]')) {
        if (container.dataset.revealSeen) continue;
        container.dataset.revealSeen = '1';

        // Marked ready — and so hidden — only now, one frame before the
        // observer can act on it.
        container.setAttribute('data-reveal-ready', '');
        observer.observe(container);
      }
    };

    observe(document);

    // Sections re-rendered by the theme editor, and anything fetched through
    // the Section Rendering API, arrive after this has run.
    document.addEventListener('shopify:section:load', (event) => observe(event.target));
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["scroll-arrows"] && !Shopify.designMode) return;
  try {
    class ScrollArrows extends HTMLElement {
    connectedCallback() {
      this.prev = this.querySelector('[data-scroll-prev]');
      this.next = this.querySelector('[data-scroll-next]');
      if (!this.prev || !this.next) return;

      this.wraps = this.hasAttribute('wrap');

      this.prev.addEventListener('click', () => this.step(-1));
      this.next.addEventListener('click', () => this.step(1));

      this.attach();

      /**
       * ⚠️ The rail may be BELOW these buttons in the source. product-row and
       * product-feature both draw their arrows in a heading block above the row,
       * so during the initial parse the element upgrades before the rail exists
       * and `getElementById` returns null. Retrying once the document is parsed
       * is what makes those two work; a fragment injected later (the section
       * rendering API) is already whole by the time it connects, so the first
       * attempt catches that case.
       */
      if (!this.rail) {
        document.addEventListener('DOMContentLoaded', () => this.attach(), { once: true });
      }
    }

    attach() {
      const rail = document.getElementById(this.getAttribute('for'));
      if (!rail || rail === this.rail) return;
      this.rail = rail;

      /* Passive: this only reads scroll position to set a disabled state, so it
         must never be able to block the scroll it is watching. */
      rail.addEventListener('scroll', () => this.sync(), { passive: true });

      /* The rail's item width is a percentage of its own box on some callers,
         so every snap position moves when the viewport does. */
      this.resize = new ResizeObserver(() => this.sync());
      this.resize.observe(rail);

      this.sync();
    }

    disconnectedCallback() {
      if (this.resize) this.resize.disconnect();
    }

    /**
     * Where the rail has to be scrolled for each item to sit at the start of
     * the snapport.
     *
     * Scrolling by a stride does NOT work: one item plus one gap lands between
     * two snap points and `mandatory` then pulls it on by the rail's inset, so
     * every press advances slightly more than one item and the rail drifts out
     * of step with itself.
     *
     * The snapport is the scrollport less `scroll-padding`, so that offset has
     * to come off here too. Read `scroll-padding` and NOT `padding`: a rail may
     * set both to the same value, but only the former moves the snapport.
     */
    get positions() {
      const railLeft = this.rail.getBoundingClientRect().left;
      const pad = parseFloat(getComputedStyle(this.rail).scrollPaddingInlineStart) || 0;
      return [...this.rail.children].map((item) =>
        Math.round(this.rail.scrollLeft + item.getBoundingClientRect().left - railLeft - pad)
      );
    }

    step(direction) {
      if (!this.rail) this.attach();
      if (!this.rail) return;

      const current = this.rail.scrollLeft;
      const positions = this.positions;
      const target =
        direction > 0
          ? positions.find((p) => p > current + 1)
          : [...positions].reverse().find((p) => p < current - 1);

      if (target !== undefined) {
        this.rail.scrollTo({ left: target });
        return;
      }

      if (!this.wraps) {
        /* Past the last item there is still the trailing inset to reveal, so an
           end press runs to the true maximum rather than doing nothing. */
        this.rail.scrollTo({ left: direction > 0 ? this.rail.scrollWidth : 0 });
        return;
      }

      /* Easing back across every item to reach the other end reads as a glitch
         rather than as movement, so the wrap itself is instant. */
      this.rail.style.scrollBehavior = 'auto';
      this.rail.scrollTo({ left: direction > 0 ? 0 : this.rail.scrollWidth });
      requestAnimationFrame(() => {
        this.rail.style.scrollBehavior = '';
      });
    }

    /**
     * `scrollWidth - clientWidth` is the maximum scrollLeft, and the 1px
     * tolerance is because that sum lands on a fraction at most zoom levels.
     *
     * The start is the FIRST SNAP POSITION, not zero: a rail with an inset
     * rests with that inset showing at scrollLeft 0, so testing `<= 1` would
     * leave the back arrow live at the start, pointing at nothing but padding.
     */
    sync() {
      if (!this.rail || this.wraps) return;

      const max = this.rail.scrollWidth - this.rail.clientWidth;
      const start = this.positions[0] ?? 0;
      this.prev.disabled = this.rail.scrollLeft <= start + 1;
      this.next.disabled = this.rail.scrollLeft >= max - 1;
    }
  }

  if (!customElements.get('scroll-arrows')) {
    customElements.define('scroll-arrows', ScrollArrows);
  }
  } catch(e) { console.error(e); }
})();

})();
